// const postalCodeSet = new Set([
//   /^\d{5}(-\d{4})?$/, // US ZIP
//   /^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/, // Canada
//   /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/, // UK
//   /^\d{5}$/, // DE, FR, UA, ES, IT, HR, LT, EE
//   /^\d{4}$/, // BE, SI, LV, NL, CH, AT, DK, NO, LU, HU, BG, AU
//   /^\d{3}[ ]?\d{2}$/, // CZ, SK, SE, GR
//   /^\d{2}-\d{3}$/, // PL
//   /^\d{4}-\d{3}$/, // PT
//   /^\d{6}$/, // RO
//   /^[A-Z]{2}[ ]?\d{4}$/, // AE
//   /^[A-Z]\d{2}[ ]?[A-Z\d]{4}$/, // IE
//   /^[A-Z]{3}[ ]?\d{4}$/ // MT
// ])
//
// const validateZipCodeWithSet = (rule, value) => {
//   if (!value) {
//     return Promise.reject(new Error("Please enter postal code"))
//   }
//
//   const cleanValue = value.trim().toUpperCase()
//   const isValid = Array.from(postalCodeSet).some((regex) =>
//     regex.test(cleanValue)
//   )
//
//   if (!isValid) {
//     return Promise.reject(new Error("Invalid postal code format"))
//   }
//
//   return Promise.resolve()
// }
// const zipCodeRegex =
//   /^(\d{5}(-\d{4})?|[A-Z]\d[A-Z][ -]?\d[A-Z]\d|[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|\d{5}|\d{4}[ ]?[A-Z]{2}|\d{4}|\d{3}[ ]?\d{2}|\d{2}-\d{3}|\d{4}-\d{3}|\d{6}|[A-Z]{2}[ ]?\d{4}|[A-Z]\d{2}[ ]?[A-Z\d]{4}|[A-Z]{3}[ ]?\d{4})$/
import type { ValidatorRule } from "rc-field-form/lib/interface"

const zipCodeRegexUS = /^[0-9]{5}$/

const validateZipCode: ValidatorRule["validator"] = (rule, value) => {
  if (!value?.trim() && !rule?.required) {
    return Promise.resolve()
  }

  if (!value) {
    return Promise.reject(new Error("Please enter zip code"))
  }

  const cleanValue = value.trim().toUpperCase()

  if (!zipCodeRegexUS.test(cleanValue)) {
    return Promise.reject(new Error("Invalid postal code format"))
  }

  return Promise.resolve()
}

export { zipCodeRegexUS, validateZipCode }
